import { Icon } from '@chakra-ui/react';
import { BsPlus } from 'react-icons/bs';

const PlusIcon = (props) => {
  return (
    <Icon as={BsPlus} {...props} />
  );
}

export default PlusIcon;